import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import useUrlQuery from './useUrlQuery';

const useWebview = () => {
  const [isWebview, setIsWebview] = useState(false);

  const searchUrl = useUrlQuery();
  const { pathname } = useLocation();

  const isRetreatWebview =
    searchUrl.get('show-cookie-consent') === 'false' &&
    pathname.includes('/retreat/');

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    setIsWebview(userAgent.includes('insighttimerapp'));
  }, []);

  return { isWebview, isRetreatWebview };
};

export default useWebview;
